// React.
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

// Types.
import InstanceTarget from '../../../types/instance/InstanceTarget';
import { Parameter } from '../../../types/instance/Parameter';

// Helper.
import { fetchResults } from '../../../helpers/utils';
import DatasourceParameterApi from '../../../api/instance/DatasourceParameterApi';
import { showError } from '../../../utils/showAlert';

// Contexts.
import { TimeRangeContext } from "../../../context/TimeRangeContext";

// Components.
import ParameterTable from '../../../component/instance/table/ParameterTable';

export default function Parameters(props:
                                   {
                                       instance: InstanceTarget,
                                       applyPeriod: Function
                                   }) {
    const { instance } = props;
    const timeRangeContext = useContext(TimeRangeContext);

    const [parameterData, setParameterData] = useState<Parameter[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!instance.detectchanges) {
            navigate(`/not-found`)
        }
    });

    useEffect(() => {
        async function load() {
            try {
                setLoading(true);
                const results: any[][] = await fetchResults(
                        [
                            DatasourceParameterApi.fetch(timeRangeContext.getTimeRangeQueryString(), instance.id)
                        ]);

                if (active) {
                    setParameterData(results[0]);
                    setLoading(false);
                }
            } catch (x: any) {
                console.log(x.message);
                const errorMessage = x.message || x.toString();
                setError(errorMessage);
                showError('Failed to load parameters', errorMessage);
                setParameterData([]);
                setLoading(false);
            }
        }

        let active: boolean = true;
        load();
        return () => {
            // Clean up afterwards to avoid race conditions.
            active = false;
        }
    }, [instance.id, timeRangeContext]);

    return (<>
        <div className="row row-cols-1">
            <div id="parameters" className="tab-pane fade show active" role="tabpanel" aria-labelledby="parameters-tab">
                <ParameterTable error={error} loading={loading}
                                data={parameterData}/>
            </div>
        </div>
    </>)
}
